export const serialize = (obj) => Object.entries(obj)
    .reduce((qs, [key, val]) => (key && val != null ? `${qs}&${key}=${encodeURIComponent(val)}` : qs), '')
    .replace(/^&/, '');
const qsRE = /\?/g;
const hasQueryString = (value) => qsRE.test(value);
export const withQueryParams = (url = '', params = {}) => {
    const qs = serialize(params);
    return `${url}${qs ? `${hasQueryString(url) ? '&' : '?'}${qs}` : ''}`;
};
//# sourceMappingURL=with-query-params.js.map